import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMemory, faTrash, faPlus, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { registerMemory, getMemory } from "./Api.js";
import { getConfig } from "./Utils";

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  /* @QUARANTINE */
  /* 
  const [items, setItems] = useState([]);

  useEffect(() => {
    getMemory().then(memory=>{
      setItems(memory);
    })
  }, []); 

  useEffect(() => {
    sessionStorage.setItem('memory', JSON.stringify(items));
  }, [items]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const addItem = () => {
    setItems([...items, ""]);
  };

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  const updateItem = (index, value) => {
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
  };

  const saveItems = () => {
    registerMemory(items).then(t=>{
      toggleModal();
    });
  };
  */

  const logout = () => {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('domain');
    sessionStorage.removeItem('clientId');
    sessionStorage.removeItem('logged');
    window.location.reload();
  };

  return (<>
    <div className="background-overlay"></div>
    <div style={{position: "fixed", width: "100%", left: 0, top: 0, background: "#f7fdfa", zIndex: 5, height: 70}}></div>
    <div style={{
      background: "linear-gradient(180deg, #f7fdfa, #f7fdfa00)",
      height: 100,
      position: "fixed",
      width: "100%",
      left: 0,
      top: 50,
      zIndex: 5
    }}>
      <div className="logout-icon">
        <FontAwesomeIcon
          icon={faSignOutAlt}
          onClick={logout}
        />
      </div>
      <div className="header">
        <h1>{getConfig()?.name}</h1>
      </div>
    </div>
  </>);
};

export default Header;
